<template>
  <a-modal
    title="一键排课"
    :width="660"
    :visible="visible"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="{'padding':'10px 25px'}"
  >
    <div class="game-setting-page">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 15 }"
              label="开始日期   "
            >
              <a-date-picker placeholder="请选择日期" v-decorator="[
                  'startDate',
                  {rules: [{ required: true, message: '请选择日期' }]}
                ]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 15 }"
              label="结束方式   "
            > 

            <j-dict-select-tag  v-decorator="[
                  'endMode',
                  {rules: [{ required: true, message: '请选择结束方式' }]}
                ]"
                :triggerChange="true" placeholder="请选择结束方式"
                dictCode="courseEndMode" @change="kk"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="endMode==2">
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 15 }"
              label="结束日期   "
            > 
              <a-date-picker placeholder="请选择结束日期" v-decorator="[
                  'endDate',
                  {rules: [{ required: true, message: '请选择结束日期' }]}
                ]"/>
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row>
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 15 }"
              label="是否重复   "
            > 

            <j-dict-select-tag  v-decorator="[
                  'repeatType',
                  {rules: [{ required: true, message: '请选择是否重复' }]}
                ]"
                :triggerChange="true" placeholder="请选择是否重复"
                dictCode="repeatType"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item
              style=""
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 15 }"
              label="周几上课   "
            > 

            <j-dict-select-tag type="checkbox" v-decorator="[
                  'weeklyCycle',
                  {rules: [{ required: true, message: '请选择周几上课' }]}
                ]"
                placeholder="请选择周几上课"
                dictCode="week" :triggerChange="true" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>

          <a-col :span="24">
            <a-form-item
              style="margin-bottom:0px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }"
              label="上课时间   "
            > 
              <a-form-item
                style="margin-bottom:0px;display:inline-block"
                :label-col="{ span: 0 }"
                :wrapper-col="{ span: 24 }"
                label=""
              > 
                <a-time-picker style="width:160px" v-decorator="[
                      'startTime',
                      {rules: [{ required: true, message: '请选择开始时间' }]}
                    ]" placeholder="请选择开始时间">
                </a-time-picker>
              </a-form-item>

              <a-form-item
                style="margin-bottom:0px;display:inline-block;margin-left:10px"
                :label-col="{ span: 0 }"
                :wrapper-col="{ span: 24 }"
                label=" "
              > 
                <a-time-picker style="width:160px" v-decorator="[
                      'endTime',
                      {rules: [{ required: true, message: '请选择结束时间' }]}
                    ]" placeholder="请选择结束时间">
                </a-time-picker>
              </a-form-item>

            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 14 }"
              label="上课老师   "
            > 
            <a-select v-decorator="[
                `teacherIds`,
                {rules: [{ required: true, message: '请选择上课老师'}]},
              ]" placeholder="请选择上课老师">
                <a-select-option v-for="(item,i) in myTeacherList" :key="i" :value="item.id">{{item.realname}}</a-select-option>
              </a-select>
            <!-- <j-dict-select-tag  v-decorator="['teacherIds', {rules: [{ required: false, message: '请选择上课老师' }]}, ,{}]" placeholder="请选择直采产品经理" 
                 dictCode="sys_user,realname,id" :triggerChange="true"/> -->
            <!-- <a-select
                placeholder="请选择上课老师"
                style="width: 120px;margin-right:15px;"
                v-decorator="[
                  `teacherIds`,
                  {rules: [{ required: true, message: '请选择上课老师' }]}
                ]"
              >
                <a-select-option
                  :value="op.id"
                  v-for="(op,index) in allElesList"
                  :key="index"
                >{{op.name}}</a-select-option>
              </a-select> -->
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }"
              label="上课内容   "
            > 
              <a-textarea v-decorator="[
                    'courseContent',
                    {rules: [{ required: true, message: '请输入上课内容' }]}
                  ]" placeholder="请输入上课内容" style="height:80px" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
// import moment from 'moment'
// import pick from 'lodash.pick'
// import { FormTypes } from '@/utils/JEditableTableUtil'
// import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'

import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";

import pick from "lodash.pick";

import { gameImgUpload, addGradeTable ,getGradeDetail,edieGradeTable} from "@/api/api";

import moment from 'moment';

export default {
  name: "GameTypeSelectModal",
  mixins: [],
  props: {},
  data() {
    return {

      gameName: "",
      gameDesc: "",
      bigImg:"",
      correctImg:"",
      findImgList: [],
      successAudioFile: "",
      startAudioFile:"",
      failAudioFile: "",
      allElesList: [],
      visible: false,
      gameImgList: [],
      pageNo: "1",
      pageSize: 10,
      total: 0,
      pageOrigin: 0, //0 背景 1 图片 2 换按钮图片
      url: {
        fileUpload: window._CONFIG["domianURL"] + "/sys/common/upload"
      },
      form: this.$form.createForm(this),
      failAudioloading: false,
      successAudioloading: false,
      startAudioloading: false,
      myTeacherList:[],
      gradeId:"",
      endMode:"",
      tableDetail:{}
    };
  },
  methods: {
    kk(e){
      this.endMode = e;
    },
    getGradeDetail(id){
      getGradeDetail({id:id}).then((res)=>{
        if(res.code==0){
          this.myTeacherList = res.result.gradeTeacherList || [];
        }else{
          this.$message.warning(res.message);
        }

      }).finally(() => {
        
      })
    },
    normFile(e) {
      console.log("Upload event:", e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.file.response.result;
    },
    delLinePei(i) {
      this.findImgList.splice(i, 1);
    },
    addLinePei() {
      this.findImgList.push("");
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
            let param = {
              ...values
            }

            param['gradeId'] = this.gradeId;
            param['startTime'] = param['startTime'].format('HH:mm:ss');
            param['endTime'] = param['endTime'].format('HH:mm:ss');
            param['startDate'] = param['startDate'].format('YYYY-MM-DD');
            param['endDate'] = param['endDate']?param['endDate'].format('YYYY-MM-DD'):"";
            
            param['weeklyCycle'] = param['weeklyCycle'].join(',');

            let opFun = "";
            if(this.tableDetail&&this.tableDetail.id){
              param['id'] = this.tableDetail.id;
              opFun = edieGradeTable(param);
            }else{
              opFun = addGradeTable(param)  
            }

            opFun.then((res)=>{
            if(res.success==true){
              this.visible = false;
              this.$message.success(res.message);
              this.$emit('ok')
              // this.loadData();
            }else{
              this.$message.warning(res.message);
            }

          }).finally(() => {
            
          })

        }
      });
      // this.visible = false;
      // if(this.selectCurType==1){
      //   this.$router.push({ path:'/myGame/gameEditor?courseId='+this.courseId+"&chapterId="+this.chapterId});
      // }
    },
    handleCancel() {
      this.visible = false;
    },
    add(clsId,item) { 

      this.gradeId = clsId;
      this.tableDetail = item;
      this.getGradeDetail(clsId);

      if(this.tableDetail){
        this.endMode = this.tableDetail.endMode;
        let item  = JSON.parse(JSON.stringify(this.tableDetail));

        item['weeklyCycle'] = item['weeklyCycle'].split(',');
        item['startDate'] = moment(item['startDate']);
        item['endDate'] = item['endDate']?moment(item['endDate']):"";
        
        item['startTime'] = item['startTime']?moment(item['startTime'], 'HH:mm:ss'):"";
        item['endTime'] = item['endTime']?moment(item['endTime'], 'HH:mm:ss'):"";
        this.$nextTick(() => {
          
          _this.form.setFieldsValue(pick(item, 
          "startDate", "endMode","repeatType",'weeklyCycle',
          'startTime','endTime','teacherIds','courseContent'
          ));
          if(item.endMode=="2"){
            _this.form.setFieldsValue(pick(item,"endDate"));
          }
        });
      }

      let _this = this;
      _this.visible = true;

    },
    selectType(i) {
      this.selectCurType = i;
    },
   
  },
  mounted() {
    // this.getImgListData();
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { "X-Access-Token": token, "X-Access-Admin": "admin" };
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  }
};
</script>

<style lang="scss" scoped >
.game-setting-page {
  min-height: 400px;
  .line-data-list {
    .line-data-item {
      margin-bottom: 10px;
      .line-data-select {
        margin-right: 10px;
      }
      .del-line-data {
        color: red;
        cursor: pointer;
        margin-left: 10px;
        vertical-align: top;
        margin-top: 14px;
      }
    }
  }
}
.img-upload-list-pager {
  text-align: center;
  .ant-pagination {
    display: inline-block;
  }
}
.voice-item {
  float: left;
  margin-right: 20px;
  .voice-item-title {
    text-align: center;
    padding: 5px 0px;
  }
}
</style>